<template>
  <div>
    <div class="p-y-10 p-relative">
      <div v-for="f in staticFilters" :key="f.key">
        <modal
          :name="`${modal}`"
          :adaptive="true"
          :clickToClose="true"
          :reset="true"
          :scrollable="true"
          :height="'auto'"
          :width="500"
        >
          <div class="shadow-wrapper" @click="closeModal"></div>
          <card class="card-modal">
            <div class="card-modal-bg"></div>
            <label class="m-b-3">{{ f.title }}</label>
            <radio-list
              :name="`${f.key}-filter`"
              v-model="params[f.key]"
              :items="f.items"
              @closeModal="closeModal"
              @input="params['page'] = 1"
            />
          </card>
        </modal>
        <div>

        </div>
        <nova-select
          style=" left: 170px; top: 50px;max-width: 380px;"
          class="m-b-1"
          :value-name="'id'"
          :name-name="'title'"
          :title="title"
          :items="staticFilters[0].items"
          v-model="params[staticFilters[0].key]"
        ></nova-select>
        <!-- <div @click="openModal" class="form-control input-style-cells">
          <span v-if="params[f.key]" class="__title">
             {{ f.items.find(e => e.id == params[f.key]).title }}
          </span>
          <span v-else class="__title empty">
            Не выбрано
          </span>
          <span class="arrow-angle ti-angle-down"></span>
        </div> -->
      </div>
      <span v-if="params['day'] == 2" class="d-inline-block">
        <selector
          :title="`Выберите учебный год (обязательно)`"
          :prefix="`season`"
          :modal="'season'"
          :selectKey="'title'"
          v-model="params['season']"
        />
      </span>
      <list
        v-if="init"
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :params="params"
        :isUpdate="true"
        :isAdd="false"
        :itemLink="itemLink"
        :setLink="setLink"
        :fields="fields"
        :searchDisable="true"
        @change="change"
        @changeFunction="changeFunction"
        @close="$emit('close')"
        v-model="val"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // close: {
    //   default: function(){},
    // },
    group_id: {
      default: null,
    },
    discipline_id: {
      default: null,
    },
  },
  components: {
    "list-item": () => import("@/components/Modals/ListItem"),
  },
  created() {
    this.itemLink = `business/teacher_groups/${this.group_id}/journals/${this.discipline_id}/timetables`;
  },
  watch: {
    discipline_id(val) {
      this.init = false;
      this.itemLink = `business/teacher_groups/${this.group_id}/journals/${val}/timetables`;
      setTimeout(() => {
        this.init = true;
      }, 10);
    },
  },
  name: "timetables",
  methods: {
    changeFunction(val) {},
    change(val) {},
    openModal() {
      this.$modal.show('puplis-radio-filter')
    },
    closeModal() {
      console.log('click')
      this.$modal.hide(`${this.modal}`);
    },
    accept() {
      if (this.val) {
        this.$modal.hide(`${this.modal}`);
        this.$emit("input", this.val);
        this.val = [];
      }
    },
  },
  data() {
    return {
      season: null,
      modal: "puplis-radio-filter",
      staticFilters: [
        {
          title: "Показать дни:",
          key: "day",
          default: "1",
          items: [
            {
              id: 1,
              title: "Сегодняшние и прошедшие",
            },
            {
              id: 3,
              title: "Сегодняшние и будущие",
            },
            {
              id: 2,
              title: "фильтровать по учебному году",
            },
          ],
        },
      ],

      init: true,
      params: {},
      filters: [
        {
          key: "course",
          title: "Номер Класса",
        },
        {
          key: "discipline",
          title: "Дисциплина",
        },
      ],
      val: [],
      /**START ADD ITEM */
      modalCreate: "timetable",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_timetable",
      itemLink: "",
      setLink: "",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "date",
          title: "Дата урока",
          dateFormat: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "part",
          title: "Четверть",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "schedule",
          object: "position",
          title: "Номер урока",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "lessonplan",
          disableLink: true,
          title: "Плановый урок",
          object: "title",
          checkbox: false,
          full: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
.scroll {
  position: absolute;
  overflow: scroll;
  width: 100%;
  height: 100%;
}
</style>
